module.exports = __webpack_public_path__ + "static/20230619_200-5a1f0b3b7a8e05491f386715ed1a2d33.jpg";